export default {
  moduleName: 'manager',
  apis: [
      {
          funName: 'login',
          methodType: 'post',
          url: 'login'
      },
      {
        funName: 'modifyPassword',
        methodType: 'post',
        url: 'password/modify'
      }
  ]
}